import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-odontologico`

    return {
        index() {
            return repository.get(`${baseUrl}`);
        },
        list(queryParams) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParams)}`)
        },
        getUnidades(queryParams) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParams)}`)
        },
        getEquipes(queryParams) {
            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParams)}`)
        }
    }
}